import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { white, grayLight } from '@bufferapp/ui/style/colors';

const NavList = styled.ul`
  margin: 0;
  padding: 0;
  position: relative;
  border-bottom: 1px solid ${grayLight};
  box-sizing: border-box;
`;

const NavWrapper = styled.nav`
  background-color: ${white};
  padding: 0 0.5rem;
  z-index: 1;
`;

const Nav = ({ children, disabled }) => (
  <NavWrapper
    aria-label={disabled ? 'Connect a channel to explore the tabs' : undefined}
    aria-disabled={disabled}
  >
    <NavList>{children}</NavList>
  </NavWrapper>
);

Nav.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

Nav.defaultProps = {
  disabled: false,
};

export default Nav;
